export const colors = [
    '#99ffff',
    '#99ffc7',
    '#99c0ff',
    '#99a5ff',
    '#aa99ff',
    '#c099ff',
    '#dd99ff',
    '#f599ff',
    '#ff99dd',
    '#ff99ad',
];

export const snowColor = [`#ffffff`];

export const ape = {
    fullScreen: {
        enable: false,
        zIndex: 0,
    },
    backgroundMode: {
        zIndex: 0,
        enable: false,
    },
    fpsLimit: 100,
    particles: {
        number: {
            value: 0,
            density: {
                enable: true,
                value_area: 100,
            },
        },
        color: {
            value: colors,
            animation: {
                enable: false,
                speed: 20,
                sync: true,
            },
        },
        shape: {
            type: 'circle',
        },
        opacity: {
            value: 1,
            random: true,
            animation: {
                enable: true,
                speed: 3,
                minimumValue: 0.1,
                sync: false,
            },
        },
        size: {
            value: 3,
            random: true,
        },
        links: {
            enable: false,
            distance: 100,
            color: '#ffffff',
            opacity: 0.4,
            width: 1,
        },
        move: {
            enable: true,
            size: true,
            straight: false,
            speed: 2,
            direction: 'none',
            outModes: {
                default: 'destroy',
            },
            random: true,
        },
        reduceDuplicates: true,
    },
    detectRetina: true,
    emitters: [
        {
            direction: 'top',
            rate: {
                delay: 0.4,
                quantity: 1,
            },
            position: {
                x: 52,
                y: 50,
            },
            size: {
                width: 23,
                height: 40,
            },
            shape: 'circle',
        },
        {
            direction: 'left',
            rate: {
                delay: 0.4,
                quantity: 1,
            },
            position: {
                x: 52,
                y: 50,
            },
            size: {
                width: 23,
                height: 40,
            },
            shape: 'circle',
        },
        {
            direction: 'right',
            rate: {
                delay: 0.4,
                quantity: 1,
            },
            position: {
                x: 52,
                y: 50,
            },
            size: {
                width: 23,
                height: 40,
            },
            shape: 'circle',
        },
        {
            direction: 'top-right',
            rate: {
                delay: 0.4,
                quantity: 1,
            },
            position: {
                x: 52,
                y: 50,
            },
            size: {
                width: 1,
                height: 40,
            },
            shape: 'circle',
        },
        {
            direction: 'top-left',
            rate: {
                delay: 0.4,
                quantity: 1,
            },
            position: {
                x: 52,
                y: 50,
            },
            size: {
                width: 1,
                height: 40,
            },
            shape: 'circle',
        },
    ],
};

export const gold = {
    fullScreen: {
        enable: true,
    },
    fpsLimit: 60,
    particles: {
        groups: {
            z5000: {
                number: {
                    value: 70,
                },
                zIndex: {
                    value: 5000,
                },
            },
            z7500: {
                number: {
                    value: 30,
                },
                zIndex: {
                    value: 75,
                },
            },
            z2500: {
                number: {
                    value: 50,
                },
                zIndex: {
                    value: 25,
                },
            },
            z1000: {
                number: {
                    value: 40,
                },
                zIndex: {
                    value: 10,
                },
            },
        },
        number: {
            value: 400,
            density: {
                enable: false,
                value_area: 800,
            },
        },
        color: {
            value: ['#FFD700', '#FFA500', '#EEE8AA', '#ff0404', '#ff1616'],
            animation: {
                enable: false,
                speed: 15,
                sync: true,
            },
        },
        shape: {
            type: 'triangle',
        },
        opacity: {
            value: 1,
            random: true,
            animation: {
                enable: true,
                speed: 2,
                minimumValue: 0.1,
                sync: false,
            },
        },
        size: {
            value: 2,
            random: true,
        },
        links: {
            enable: false,
            distance: 20,
            color: '#ffffff',
            opacity: 0.1,
            width: 1,
        },
        rotate: {
            value: {
                min: 0,
                max: 360,
            },
            animation: {
                enable: true,
                speed: 10,
                sync: true,
            },
        },
        move: {
            enable: true,
            speed: 3,
            direction: 'top',
            random: true,
            straight: false,
            outModes: {
                default: 'out',
            },
            attract: {
                enable: false,
                rotateX: 1000,
                rotateY: 1200,
            },
            trail: {
                enable: false,
                fillColor: '#000000',
                length: 100,
            },
        },
        zIndex: {
            value: 5,
            opacityRate: 0.5,
        },
    },
    interactivity: {
        detectsOn: 'window',
        events: {
            onHover: {
                enable: false,
                mode: 'repulse',
            },
            onClick: {
                enable: true,
                mode: 'push',
            },
            resize: true,
        },
        modes: {
            grab: {
                distance: 400,
                links: {
                    opacity: 1,
                },
            },
            bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 0.8,
            },
            repulse: {
                distance: 200,
            },
            push: {
                quantity: 4,
                groups: ['z5000', 'z7500', 'z2500', 'z1000'],
            },
            remove: {
                quantity: 2,
            },
        },
    },
    detectRetina: true,
    emitters: {
        position: {
            y: 55,
            x: -30,
        },
        rate: {
            delay: 7,
            quantity: 1,
        },
        size: {
            width: 0,
            height: 0,
        },
        particles: {
            size: {
                value: 40,
            },
            move: {
                speed: 10,
                outModes: {
                    default: 'destroy',
                    left: 'none',
                },
                straight: false,
            },
            zIndex: {
                value: 0,
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360,
                },
                animation: {
                    enable: true,
                    speed: 10,
                    sync: true,
                },
            },
        },
    },
    backgroundMode: {
        zIndex: 1,
        enable: true,
    },
};

export const snow = {
    fullScreen: {
        enable: true,
    },
    fpsLimit: 60,
    particles: {
        groups: {
            z5000: {
                number: {
                    value: 70,
                },
                zIndex: {
                    value: 5000,
                },
            },
            z7500: {
                number: {
                    value: 30,
                },
                zIndex: {
                    value: 75,
                },
            },
            z2500: {
                number: {
                    value: 50,
                },
                zIndex: {
                    value: 25,
                },
            },
            z1000: {
                number: {
                    value: 40,
                },
                zIndex: {
                    value: 10,
                },
            },
        },
        number: {
            value: 400,
            density: {
                enable: false,
                value_area: 800,
            },
        },
        color: {
            value: snowColor,
            animation: {
                enable: false,
                speed: 20,
                sync: true,
            },
        },
        shape: {
            type: 'circle',
        },
        opacity: {
            value: 1,
            random: true,
            animation: {
                enable: true,
                speed: 2,
                minimumValue: 0.1,
                sync: false,
            },
        },
        size: {
            value: 3,
            random: true,
        },
        links: {
            enable: false,
            distance: 20,
            color: '#ffffff',
            opacity: 0.1,
            width: 1,
        },
        move: {
            enable: true,
            speed: 3,
            direction: 'bottom',
            random: true,
            straight: false,
            outModes: {
                default: 'out',
            },
            attract: {
                enable: false,
                rotateX: 1000,
                rotateY: 1200,
            },
            trail: {
                enable: false,
                fillColor: '#000000',
                length: 100,
            },
        },
        zIndex: {
            value: 5,
            opacityRate: 0.5,
        },
    },
    interactivity: {
        detectsOn: 'window',
        events: {
            onHover: {
                enable: false,
                mode: 'repulse',
            },
            onClick: {
                enable: true,
                mode: 'push',
            },
            resize: true,
        },
        modes: {
            grab: {
                distance: 400,
                links: {
                    opacity: 1,
                },
            },
            bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 0.8,
            },
            repulse: {
                distance: 200,
            },
            push: {
                quantity: 4,
                groups: ['z5000', 'z7500', 'z2500', 'z1000'],
            },
            remove: {
                quantity: 2,
            },
        },
    },
    detectRetina: true,
    emitters: {
        position: {
            y: 55,
            x: -30,
        },
        rate: {
            delay: 7,
            quantity: 1,
        },
        size: {
            width: 0,
            height: 0,
        },
        particles: {
            size: {
                value: 40,
            },
            move: {
                speed: 10,
                outModes: {
                    default: 'destroy',
                    left: 'none',
                },
                straight: false,
            },
            zIndex: {
                value: 0,
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360,
                },
                animation: {
                    enable: true,
                    speed: 10,
                    sync: true,
                },
            },
        },
    },
    backgroundMode: {
        zIndex: 1,
        enable: true,
    },
};

export const magic = {
    fullScreen: {
        enable: true,
    },
    fpsLimit: 60,
    particles: {
        groups: {
            z5000: {
                number: {
                    value: 70,
                },
                zIndex: {
                    value: 5000,
                },
            },
            z7500: {
                number: {
                    value: 30,
                },
                zIndex: {
                    value: 75,
                },
            },
            z2500: {
                number: {
                    value: 50,
                },
                zIndex: {
                    value: 25,
                },
            },
            z1000: {
                number: {
                    value: 40,
                },
                zIndex: {
                    value: 10,
                },
            },
        },
        number: {
            value: 500,
            density: {
                enable: false,
                value_area: 800,
            },
        },
        color: {
            value: colors,
            animation: {
                enable: false,
                speed: 20,
                sync: true,
            },
        },
        shape: {
            type: 'circle',
        },
        opacity: {
            value: 1,
            random: true,
            animation: {
                enable: true,
                speed: 3,
                minimumValue: 0.1,
                sync: false,
            },
        },
        size: {
            value: 4,
            random: true,
        },
        links: {
            enable: false,
            distance: 20,
            color: '#ffffff',
            opacity: 0.1,
            width: 1,
        },
        move: {
            enable: true,
            speed: 5,
            direction: 'top',
            random: true,
            straight: false,
            outModes: {
                default: 'out',
            },
            attract: {
                enable: false,
                rotateX: 1000,
                rotateY: 1200,
            },
            trail: {
                enable: false,
                fillColor: '#000000',
                length: 100,
            },
        },
        zIndex: {
            value: 5,
            opacityRate: 0.5,
        },
    },
    interactivity: {
        detectsOn: 'window',
        events: {
            onHover: {
                enable: false,
                mode: 'repulse',
            },
            onClick: {
                enable: true,
                mode: 'push',
            },
            resize: true,
        },
        modes: {
            grab: {
                distance: 400,
                links: {
                    opacity: 1,
                },
            },
            bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 0.8,
            },
            repulse: {
                distance: 200,
            },
            push: {
                quantity: 4,
                groups: ['z5000', 'z7500', 'z2500', 'z1000'],
            },
            remove: {
                quantity: 2,
            },
        },
    },
    detectRetina: true,
    emitters: {
        position: {
            y: 55,
            x: -30,
        },
        rate: {
            delay: 7,
            quantity: 1,
        },
        size: {
            width: 0,
            height: 0,
        },
        particles: {
            size: {
                value: 40,
            },
            move: {
                speed: 10,
                outModes: {
                    default: 'destroy',
                    left: 'none',
                },
                straight: false,
            },
            zIndex: {
                value: 0,
            },
            rotate: {
                value: {
                    min: 0,
                    max: 360,
                },
                animation: {
                    enable: true,
                    speed: 10,
                    sync: true,
                },
            },
        },
    },
    backgroundMode: {
        zIndex: 1,
        enable: true,
    },
};
